import React, { useState } from 'react';

import { Navbar } from '@/components/organisms/Navbar';
import { SideBar } from '@/components/organisms/SideBar';

type Props = {
  children?: React.ReactNode | React.ReactNode[];
};

export const PublicLayout = ({ children }: Props): JSX.Element => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return (
    <div className="flex h-screen w-screen">
      <Navbar />
      <SideBar sidebarOpen={sidebarOpen} onChangeSidebar={(value) => setSidebarOpen(value)} />

      {children}
    </div>
  );
};
